export default (allChannels, filterChannels) =>
  allChannels.filter(
    (all) =>
      !!filterChannels.find(
        (filter) =>
          ((filter.company && all.company === filter.company) || !filter.company) &&
          ((filter.name && all.name === filter.name) || !filter.name) &&
          ((filter.category && all.category === filter.category) || !filter.category)
      )
  );
